import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cust-check-mark",
  "use": "cust-check-mark-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cust-check-mark\"><path d=\"M20.285 2 9 13.567 3.714 8.556 0 12.272 9 21 24 5.715z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol